import { TPurchase } from "@/api";

export const isFinishedPurchase = (purchase: TPurchase) => {
  if (!purchase) return true;
  return ["DONE", "CANCELLED"].includes(purchase.status);
};
